import fetch from './fetch';

// 资讯信息
const getInformation = params => fetch({ url: '/information', params });
const informationType = () => fetch({ url: '/information_type' });
const addInformation = ({ params }) => fetch({ url: '/information', params, methold: 'post' });

const controlInformation = ({ params, id, methold }) => fetch({ url: `/information/${id}`, params, methold });
// 场馆
const createVenue = ({ params }) => fetch({ url: '/create_venue', params, methold: 'post' });
const getVenue = params => fetch({ url: '/get_venue', params });
const controlVenue = ({ params, methold, id }) => fetch({ url: `/venue_operation/${id}`, params, methold });
// 前台信息管理
const controlSiteInf = ({ params, id }) => fetch({ url: `/site_information/${id}`, params });
const getOpinions = params => fetch({ url: '/get_opinion_list', params });
const opinionOperate = ({ id, methold }) => fetch({ url: `/opinion_operate/${id}`, methold });
const getQuestion = params => fetch({ url: '/get_question', params });
const createQuestion = ({ params }) => fetch({ url: '/create_question', params, methold: 'post' });
const controlQuestion = ({ params, methold, id }) => fetch({ url: `/question_operate/${id}`, params, methold });
const getContactInfo = params => fetch({ url: '/get_contact_info', params });
const controlContactInfo = ({ params, methold, id }) => fetch({ url: `/contact_info_operate/${id}`, params, methold });
const createContactInfo = ({ params }) => fetch({ url: '/create_contact_info', params, methold: 'post' });

const getCooperation = params => fetch({ url: '/get_cooperation_list', params });
const controlCooperation = ({ params, methold, id }) =>
  fetch({ url: `/change_cooperation_status/${id}`, params, methold });
const cooperationStatus = () => fetch({ url: 'cooperation_status_enum' });

// 富文本模块
const getFrontContent = ({ params }) => fetch({ url: '/get_front_content', params });
const setFrontContent = ({ params }) => fetch({ url: '/front_information', params, methold: 'post' });

// 系统公告
const sysAnnouncementQuery = params => fetch({ url: '/sys_announcement_query', params });
const sysAnnouncement = ({ params }) => fetch({ url: '/sys_announcement_query', params, methold: 'post' });
const operateSysAnnouncement = ({ params, id, methold }) =>
  fetch({ url: `/operate_sys_announcement/${id}`, params, methold });

const publishSysAnnouncement = ({ id }) => fetch({ url: `/publish_sys_announcement/${id}`, methold: 'post' });
const revokeSysAnnouncement = ({ id }) => fetch({ url: `/revoke_sys_announcement/${id}`, methold: 'post' });

// app管理
const getVersion = params => fetch({ url: '/version_management', params });
const addVersion = ({ params }) => fetch({ url: '/version_management', params, methold: 'post' });
const controlVersion = ({ params, version_id, methold }) => fetch({ url: `/version_management/${version_id}`, params, methold });
const versionPublish = ({ version_id, app_type }) => fetch({ url: `/version_publish/${version_id}/${app_type}`, methold: 'put' });
const appType = () => fetch({ url: '/version_app_type' });

export default {
  appType,
  versionPublish,
  controlVersion,
  addVersion,
  getVersion,
  sysAnnouncementQuery,
  revokeSysAnnouncement,
  publishSysAnnouncement,
  operateSysAnnouncement,
  sysAnnouncement,
  getInformation,
  addInformation,
  controlInformation,
  createVenue,
  getVenue,
  controlVenue,
  controlSiteInf,
  getOpinions,
  opinionOperate,
  getQuestion,
  controlQuestion,
  createQuestion,
  getContactInfo,
  controlContactInfo,
  informationType,
  createContactInfo,
  getFrontContent,
  setFrontContent,
  getCooperation,
  controlCooperation,
  cooperationStatus
};
